/** @type import('next-translate').I18nConfig */
module.exports = {
  locales: ['en'],
  defaultLocale: 'en',
  extensionsRgx: /\.page\.(tsx|ts|js|mjs|jsx)$/,
  pages: {
    '*': ['common'],
    '/': ['onboarding'],
    '/offer': ['cc-offer'],
    '/onboarding-sso': ['onboarding'],
  },
};
